"use client";
import CMSPage from "@/components/CMSPage/CMSPage";

const TermsAndConditionsPage = () => {
    return (
        <CMSPage 
            apiEndpoint="/cms-pages1/MQ=="
            pageTitle="Terms and Conditions"
            defaultDescription="Welcome to www.hyrelancer.com. By accessing and using our website, you agree to comply with and be bound by these Terms and Conditions."
        />
    );
};

export default TermsAndConditionsPage;

